import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import Select, { components } from 'react-select';
import Alert from '../Alert';
import { ajaxFeedbackTags } from '../redux/FeedbackRedux';
import ReactTooltip from "react-tooltip";

class TagsSection extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.state = {is_open: false};
    }

    handleOpenChange(event) {
        event.preventDefault();
        this.setState({
            is_open: !this.state.is_open,
        });
    }

    handleChange(selectedTags) {
        var tags = []
        for (var tag in selectedTags) {
            tags.push(selectedTags[tag].value);
        }

        this.props.dispatch(ajaxFeedbackTags(this.props.feedback.feedback_id, tags));
    }

    render() {
        const options = [];
        for (const tag in this.props.tags) {
            const isTagActive = this.props.tags[tag].deleted_at === null;
            if (isTagActive) {
                options.push({ value: this.props.tags[tag].id, label: this.props.tags[tag].label });
            }
        }

        let defaultOptions = [];
        for (const i in this.props.feedback.feedback_tags) {
            const feedbackTag = this.props.feedback.feedback_tags[i];
            const isFeedbackTagActive = feedbackTag.active === 1 || feedbackTag.active === true;
            if (isFeedbackTagActive) {
                const match = options.find(
                    (element) =>
                        element.value ===
                        feedbackTag.business_group_tag_id
                );
                if (match) {
                    match.is_ai_generated = feedbackTag.auto_generated_at !== null
                    match.sentiment_score = feedbackTag.sentiment_score
                    match.sentiment_reason = feedbackTag.sentiment_reason
                    defaultOptions.push(match);
                }
            }
        }

        // Mark it with an AI-generated icon
        defaultOptions = defaultOptions.map(tag => {
            const aiIcon = '<svg class="mr-1 icon-ai-gen" width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.15.025c.101.036.19.106.253.202.063.095.097.21.097.328v2.778h2c.091 0 .181.028.26.08a.537.537 0 0 1 .183.219.608.608 0 0 1-.033.575l-3.5 5.555a.509.509 0 0 1-.249.208c-.1.038-.21.04-.311.004a.505.505 0 0 1-.253-.201.598.598 0 0 1-.097-.329V6.666h-2a.463.463 0 0 1-.26-.08.536.536 0 0 1-.183-.218.608.608 0 0 1 .033-.576L3.59.237a.509.509 0 0 1 .249-.208c.1-.038.21-.039.311-.003Z" fill="#3775B7"></path></svg>';
            const label = tag.is_ai_generated ? `${aiIcon}${tag.label}` : tag.label;

            return {
                ...tag,
                label,
            };
        });

        const CustomMultiValue = (props) => {
            const { data, index, selectProps } = props;
            return (
                <div
                    className={`d-flex flex-row justify-content-between react-select__multi-value react-select__multi-value--sentiment-${data.sentiment_score} react-select__multi-value-wrapper`}
                    data-tip={data.sentiment_reason}
                    data-for={`${index}-tags`}
                    data-tooltip-html={data.sentiment_reason}
                >
                    <div className="react-select__multi-value__label">
                        <div dangerouslySetInnerHTML={{ __html: data.label }} />
                    </div>
                    {!props.isDisabled && selectProps.isMulti && (
                        <div
                            className="react-select__multi-value__remove"
                            onClick={(e) => {
                                e.stopPropagation();
                                props.removeProps.onClick();
                            }}
                            onTouchEnd={props.removeProps.onTouchEnd}
                            aria-label="Remove"
                        >
                            ×
                        </div>
                    )}
                    <ReactTooltip id={`${index}-tags`} html={true} className="tooltip-content" effect="solid" place="top" />
                </div>
            );
        };

        const CustomMultiValueLabel = (props) => (
            <components.MultiValueLabel {...props}>
                <div dangerouslySetInnerHTML={{ __html: props.data.label }} />
            </components.MultiValueLabel>
        );

        return (
            <div className="card-body border-top tag-section">
                <Alert alert={this.props.alert} location={'tags'} />
                <div className="d-flex align-items-center mb-2">
                    <h4 className='mb-0' data-toggle="tooltip" data-title={ __('Categorizes Feedbacks for easy labeling and search-ability')}>{__('Tags')}</h4>
                    {!defaultOptions || defaultOptions?.length < 1 &&
                        <div className="ml-2">
                            {!this.state.is_open &&
                                <span className="btn btn-sm btn-primary toggle-notes ml-3 d-inline-block" onClick={this.handleOpenChange.bind(this)}>
                                                      <i className="fas fa-plus"></i>
                                                </span>
                            }
                            {this.state.is_open &&
                                <span className="btn btn-sm btn-primary btn-primary-alt toggle-notes ml-3 d-inline-block" onClick={this.handleOpenChange.bind(this)}>
                                                      <i className="fas fa-times"></i>
                                                </span>
                            }
                        </div>
                    }
                </div>

                <div className="row tags">
                    <div className="col-md-12">
                        {(this.props.current_user && (this.state.is_open || defaultOptions.length > 0)) &&
                            <Select
                                className="react-select-container w-100 "
                                classNamePrefix="react-select"
                                isMulti
                                value={defaultOptions}
                                onChange={this.handleChange}
                                options={options}
                                placeholder={__('Select')}
                                components={{
                                    MultiValue: CustomMultiValue,
                                    MultiValueLabel: CustomMultiValueLabel,
                                }}
                            />
                        }
                        {(!this.props.current_user && (this.state.is_open || defaultOptions.length > 0)) &&
                            <Select className="react-select-container w-100" classNamePrefix="react-select" isDisabled={true} isMulti value={defaultOptions} onChange={this.handleChange} options={options} placeholder={__('Select')} />
                        }
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { tag_state: state.tag_state, tags: state.feedback_detail.business.tags, feedback: state.feedback_detail, alert: state.alert.alert }
}

export default connect(mapStateToProps)(TagsSection)
